export { default } from './WalletServiceTerms';
